export default function ArrowDownIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00006 12.5859L5.41412 9L4.00006 9L4.00006 10.4141L10.0001 16.4141L16.0001 10.4141L16.0001 9L14.586 9L11.0001 12.5859L11.0001 4L9.00006 4L9.00006 12.5859Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
